'use client';

import { useState, useEffect } from 'react';

interface Props {
  sections: string[];
}

export default function CaseStudySideNav({ sections }: Props) {
  const [active, setActive] = useState(sections[0].toLowerCase());

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    sections.forEach((section) => {
      const id = section.toLowerCase();
      const el = document.getElementById(id);
      if (!el) return;

      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActive(id);
        },
        { threshold: 0.2, rootMargin: '-64px 0px -40% 0px' }
      );
      obs.observe(el);
      observers.push(obs);
    });

    return () => observers.forEach((obs) => obs.disconnect());
  }, [sections]);

  return (
    <nav className="cs-sidenav" aria-label="Case study sections">
      {sections.map((section) => {
        const id = section.toLowerCase();
        const isActive = active === id;
        return (
          <a
            key={section}
            href={`#${id}`}
            className={`cs-sidenav-item${isActive ? ' active' : ''}`}
            aria-current={isActive ? 'location' : undefined}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
              setActive(id);
            }}
          >
            {isActive && <span className="cs-sidenav-tick" aria-hidden="true" />}
            {section}
          </a>
        );
      })}
    </nav>
  );
}
